import styled from 'styled-components';
import { Editor } from 'druide-slate-react';

import { EditorType } from '../../../containers/Editor/constants';
import { NewStyleColor } from '../../../utils/styles-constants';

interface StyledEditorWrapperProps {
	editorType: EditorType;
	isActive: boolean;
	outlineWidth: number;
	width?: number;
	height?: number;
	transform?: string;
}

const StyledEditorWrapper = styled('div')`
	width: ${({ width }: StyledEditorWrapperProps) => width ? `${width}px` : ''};
	height: ${({ height }: StyledEditorWrapperProps) => height ? `${height}px` : ''};
	transform: ${({ transform }: StyledEditorWrapperProps) => transform ? transform : ''};
	overflow: hidden;
	pointer-events: auto;

	${({ editorType }: StyledEditorWrapperProps) => editorType === EditorType.INDESIGN
		? `
			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;
		`
		: 'position: relative;'
	}

	${({ isActive, outlineWidth, editorType }: StyledEditorWrapperProps) => isActive &&
		`outline: ${editorType === EditorType.INDESIGN ? outlineWidth : 2}px solid ${NewStyleColor.Blue100};`
	}

	> div {
		height: 100%;
	}

	${({ editorType }: StyledEditorWrapperProps) => editorType === EditorType.INDESIGN && `
		> div {
			position: relative;
			top: -1px;
		}
	`}

	a {
		color: inherit;
		text-decoration: none;
	}
`;

interface StyledEditorProps {
	shouldShowScrollbar: boolean;
}

const StyledEditor = styled(Editor)`
	${(props: StyledEditorProps) => props.shouldShowScrollbar &&
	`/* show scrollbar on editable text fields like in the reader */
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 12px;

	/* custom scrollbar on firefox */
	scrollbar-width: thin;
	scrollbar-color: ${NewStyleColor.Grey500} ${NewStyleColor.Grey100};

	/* custom scrollbar on chrome */
	&::-webkit-scrollbar {
		width: 3px;
		background-color: ${NewStyleColor.Grey100};
	}

	&::-webkit-scrollbar-track {
		background-color: ${NewStyleColor.Grey100};
		border-radius: 1px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${NewStyleColor.Grey500};
		border-radius: 1px;
	}

	.editable-button & {
		overflow-y: hidden;
		padding-right: 0;
	}`
	}
`;

export {
	StyledEditorWrapper,
	StyledEditor,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/styles.ts